export interface BadgeCategory {
  key: string;
  label: string;
  icon: string;
  color: string;
}

export const categories: BadgeCategory[] = [
  { key: 'reading', label: 'Reading', icon: '📚', color: '#3b82f6' },
  { key: 'writing', label: 'Writing', icon: '✏️', color: '#8b5cf6' },
  { key: 'math', label: 'Math', icon: '🔢', color: '#22c55e' },
  { key: 'art', label: 'Art & Music', icon: '🎨', color: '#ec4899' },
  { key: 'sports', label: 'Sports', icon: '⚽', color: '#f97316' },
  { key: 'science', label: 'Science', icon: '🔬', color: '#14b8a6' },
  { key: 'english', label: 'English', icon: 'EN', color: '#6366f1' },
  { key: 'chinese', label: 'Chinese', icon: '🇨🇳', color: '#ef4444' },
  { key: 'life_skills', label: 'Life Skills', icon: '🌱', color: '#10b981' },
  { key: 'social', label: 'Social', icon: '🤝', color: '#f59e0b' },
];
